import * as React from 'react';
import {default as CommonStreamItem} from "../../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import InvoiceUpdatedEvent from "../../../../model/invoice/event/InvoiceUpdatedEvent";
import BillUpdatedEvent from "../../../../model/bill/event/BillUpdatedEvent";

interface ComponentProps {
	/**
	 * Invoice/bill activity to display.
	 */
	activity: InvoiceUpdatedEvent | BillUpdatedEvent;
}

interface State {
	/**
	 * Indicates if invoice/bill changes are visible.
	 */
	changesVisible: boolean;
}

type Props = ComponentProps;

export class AccountingCommonActivityUpdatedItem extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {changesVisible: false};
	}

	render() {
		const changesButtonLabel = this.state.changesVisible ? "Hide changes" : "Show changes";
		return (
			<>
				<CommonStreamItem event={this.props.activity}/>
				<div className="c-common-details_activity-update-item-changes-container">
					<span className="t-link" onClick={() => this.setState({changesVisible: !this.state.changesVisible})}>
						{changesButtonLabel}
						{this.renderButtonArrow()}
					</span>
					{this.state.changesVisible && this.displayChanges()}
				</div>
			</>
		);
	}

	renderButtonArrow = () =>
		<span key={`${this.state.changesVisible}`}>
			{this.state.changesVisible ? <i className="fa fa-fw fa-caret-up"/> : <i className="fa fa-fw fa-caret-down"/>}
		</span>;

	displayChanges = () => {
		const activityData = this.props.activity.data;
		return (
			<ul>
				{activityData.fieldChanges.map((fc, index) => {
					return (
						<li key={index} className="c-common-details_activity-update-item-changes-container_list-element">
							{fc.getFormattedChange()}
						</li>
					);
				})}
				{activityData.itemChanges.map((ic, index) => {
					return (
						<li key={index} className="c-common-details_activity-update-item-changes-container_list-element">
							{ic.getDescription()}
							<ul>
								{ic.fieldChanges.map((fc, index) => {
									return (
										<li key={index}
											className="c-common-details_activity-update-item-changes-container_list-element">
											{fc.getFormattedChange(ic.diffType)}
										</li>
									);
								})}
							</ul>
						</li>
					);
				})}
			</ul>
		);
	};
}
